import React from "react";

const Notices = () => {
    return (
        <div className="tableWrapper">
            <div className="row">
                <div className="col-md-12 n-p-50">
                    <p className="noticeAccount caption-small" id="noticedata">NOTICE: This tool is only for use by parties
                        that have been authorized by HP pursuant to a separate, binding agreement entered into by HP and
                        such party.<br/>
                        Unauthorized use is strictly prohibited.</p>
                </div>
            </div>
        </div>
    )
}

export default Notices;